import React, { useEffect, useState } from 'react'
import { Button, Modal, Icon, Menu, Table, Label, Input, Header, Dropdown, Segment, Dimmer, Loader, Image } from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux';
import { initiate_data, delete_data, update_data, initiate_main_form, initiate_pga_data } from "../../../../actions/manageProductHistory"
import { searchProductLineHistory, getProductHistory, getProductLineHistory, addProductLineHistory, updateProductLineHistory, deleteProductLineHistory, getCustomerList, getProdHistDetails, getQueryVariable } from "../../../../apiCalls/jobInfo";
import TableApp from '../table/Table';
import { update, get } from 'lodash';
import UpdateFormUK from './UpdateFormUK';
import UpdateFormCA from "./UpdateFormCA";
import UpdateFormUS from "./UpdateFormUS";
import { getDropdownValues as getDropdownValuesCBSA } from "./../../../../CBSA_App/api/getEntrySummaryData"
import { getDropdownValues as getDropdownValuesCBP, getCountryList, getSpecialProgramList, getUnitList, getUSStateList } from "./../../../../CBP_App/api/getEntrySummaryData"
import _ from "lodash"
import "../../../../styleSheets/sass/components/manageProductHistory.scss"
import "../../../../styleSheets/sass/components/ISFForm.scss"
import "../../../../CBSA_App/styleSheets/scss/theme/forms/merchandise.scss"
import "../../../../C88_App/styleSheets/theme/forms/merchandise.scss"
import "../../../../CBP_App/styleSheets/theme/forms/merchandise.scss"
// import "../../../../CBSA_App/styleSheets/scss/components/index.scss"
import { getDropdownValues } from "../../../../C88_App/api/getC88Form"

function ManageProductHistory ({ filerCode, triggerName }) {
  const isEngine = !!getQueryVariable('onlyOneShipment')  
  const [open, setOpen] = React.useState(false);
  const [changeState, setChangeState] = React.useState(1)
  const [selectedData, setSelectedData] = React.useState(null);
  const [formOpen, setFormOpen] = React.useState(false);
  const [isLoading, setLoading ] = React.useState(false);
  const [formLoader, setFormLoader] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [neutralMessage, setNeutralMessage] = React.useState("");
  const [dropdownSet, setDropdownSet] = useState(false);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [selectedRowId, setSelectedRowId] = React.useState("");
  const [countryDropDownUK, setCountryDropDownUK] = React.useState([]);
  const [customerData, setCustomerData] = React.useState([]);
  const [getApiFlag, setGetApiFlag] = React.useState(true);
  const prodList = useSelector((state) => state.productHistory)
  const [countryToSearch, setCountryToSearch] = React.useState(() => {
    if(window.typeOfUser === "BROKER_KN_ADMIN"){
      return "US"
    }
    if(window.shipmentCountry){
      return window.shipmentCountry;
    }
    return "US"
  })
  const dispatch = useDispatch();
  const columns = [
    {
      Header: 'Name',
      accessor: 'productDescription',
      Name: 'productDescription',
    },
    {
      Header: 'HTS',
      accessor: 'HTS',
      Name: 'HTS',
    },    
    {
      Header: 'sku/product tag',
      accessor: 'productTag',
      Name: 'productTag',
    },
    {
      Header: "Customer Id",
      accessor: "customerId",
      Name: "customerId",
    },
    {
      Header: "Customer Name",
      accessor: "customerName",
      Name: "customerName",
    },
    {
      Header: 'Country',
      accessor: 'originCountry',
      Name: 'originCountry',
    },
    {
      Header: 'Manufacturer',
      accessor: 'manufacturerName',
      Name: 'manufacturerName',
    },
    {
      Header: 'Last Modified',
      accessor: 'lastModified',
      Name: 'lastModified',
    }
  ]

  const countryOptions = [
    {
      key: "US",
      value: "US",
      text: "United States"
    },
    {
      key: "UK",
      value: "GB",
      text: "Great Britain"
    },
    {
      key: "CA",
      value: "CA",
      text: "Canada"
    },
  ]

  const setDropdowns = async () => {
    // if(!sessionStorage.getItem("DROPDOWN_VAL_CBSA")){
    //   getDropdownValuesCBSA().then((response) => {
    //   })
    // }
    // if(!sessionStorage.getItem("COUNTRY_LIST")){
    //   let response = await getCountryList().then((response) => {
    //   })
    // }
    if(!sessionStorage.getItem("SPL_PROGRAM")){
      let response = await getSpecialProgramList().then((response) => {
      })
    }
    if(!sessionStorage.getItem("UNITS_LIST_NEW")){
      let response = await getUnitList().then((response) => {
      })
    }
    if(!sessionStorage.getItem("PROVINCE_LIST")){
      let response = await getUSStateList().then((response) => {
      })
    }
    if(!sessionStorage.getItem("DROPDOWN_VAL")){
      let response = await getDropdownValuesCBP().then((response) => {
      })
    }
    setDropdownSet(true)
  }

  function onlySpaces(str) {
    return /^\s*$/.test(str);
  }

  const changePageNumber = (number, searchApiFlag, data) => {
    setPageNumber(number)
    if(searchApiFlag){
      searchAPI(data, true, number);
    }
    else{
      setGetApiFlag(!getApiFlag)
    }
  }; 

  const incrStateChange = () => {
    setTimeout(() => {
      setChangeState(changeState + 1)
    }, 500)
  }
  const setSelectedRowData = (payload, id) => {
    if(payload.productDescription === "Please Wait!"){
      return;
    }
    setFormOpen(false)
    setFormLoader(true)
    dispatch(initiate_main_form({}))
    if(prodList){
      getProdHistDetails(prodList.productHistory[id].productLineId, prodList.productHistory[id].customerId, countryToSearch).then((response) => {
        if(response.data.eventMessage.productLineHistoryRecord)
        {
          setFormLoader(false)
          if(countryToSearch == "US"){
            let pgaData = response.data.eventMessage.productLineHistoryRecord[0].pgaData
            let pgaFlags = response.data.eventMessage.productLineHistoryRecord[0].pgaFlags
            let pgaJson = {
                pgaData,
                pgaFlags
            }
            delete response.data.eventMessage.productLineHistoryRecord[0].pgaData
            delete response.data.eventMessage.productLineHistoryRecord[0].pgaFlags
            response.data.eventMessage.productLineHistoryRecord[0]["launchFrom"] = "PRODUCT_HISTORY"
            dispatch(initiate_pga_data(pgaJson))
            dispatch(initiate_main_form(response.data.eventMessage.productLineHistoryRecord[0]))
          }
          else if(countryToSearch == "CA"){
            if(response.data.eventMessage.productLineHistoryRecord[0]["lineItemJsonCA"]["manufacturerName"] && !onlySpaces(response.data.eventMessage.productLineHistoryRecord[0]["manufacturerName"]))
              response.data.eventMessage.productLineHistoryRecord[0]["lineItemJsonCA"]["manufacturerStatus"] = "allowed";
            else
              response.data.eventMessage.productLineHistoryRecord[0]["lineItemJsonCA"]["manufacturerStatus"] = "waived";
            dispatch(initiate_main_form(response.data.eventMessage.productLineHistoryRecord[0]))
            dispatch(initiate_pga_data({}));
          }

          else{
            dispatch(initiate_main_form(response.data.eventMessage.productLineHistoryRecord[0]))
            dispatch(initiate_pga_data({}));
          }
          setFormOpen(true);
        }
      })
      
    } 
    setSelectedRowId(id);
    document.getElementById("form-close") && document.getElementById("form-close").focus();
  }

  const formReset = (productLineId, customerId) => {
    setFormOpen(false)
    setFormLoader(true)
    setNeutralMessage("Resetting...")
    getProdHistDetails(productLineId, customerId, countryToSearch).then((response) => {
      if(response.data.eventMessage.productLineHistoryRecord)
      {
        setFormLoader(false)
        if(countryToSearch === "US"){
          let pgaData = response.data.eventMessage.productLineHistoryRecord[0].pgaData
          let pgaFlags = response.data.eventMessage.productLineHistoryRecord[0].pgaFlags
          let pgaJson = {
              pgaData,
              pgaFlags
          }
          delete response.data.eventMessage.productLineHistoryRecord[0].pgaData
          delete response.data.eventMessage.productLineHistoryRecord[0].pgaFlags
          response.data.eventMessage.productLineHistoryRecord[0]["launchFrom"] = "PRODUCT_HISTORY"
          dispatch(initiate_pga_data(pgaJson))
          dispatch(initiate_main_form(response.data.eventMessage.productLineHistoryRecord[0]))
        }
        else if(countryToSearch == "CA"){
          if(response.data.eventMessage.productLineHistoryRecord[0]["lineItemJsonCA"]["manufacturerName"] && !onlySpaces(response.data.eventMessage.productLineHistoryRecord[0]["manufacturerName"]))
            response.data.eventMessage.productLineHistoryRecord[0]["lineItemJsonCA"]["manufacturerStatus"] = "allowed";
          else
            response.data.eventMessage.productLineHistoryRecord[0]["lineItemJsonCA"]["manufacturerStatus"] = "waived";
          dispatch(initiate_main_form(response.data.eventMessage.productLineHistoryRecord[0]))
          dispatch(initiate_pga_data({}));
        }
        else{
          dispatch(initiate_main_form(response.data.eventMessage.productLineHistoryRecord[0]))
          dispatch(initiate_pga_data({}));
        }
        setNeutralMessage("");
        setFormOpen(true);
      }
    }).catch((err) => {
      setNeutralMessage("408 error code!");
      setTimeout(() => setErrorMessage(""), 2000);
    })
  }


  const updateAPI = (data) => {
    updateProductLineHistory(data["productLineId"], data["filerCode"], data).then((response) => {
        if(_.get(response, "data.eventMessage.header.code") === 200 && _.get(response, "data.eventMessage.header.msg") === "SUCCESS"){
          //data["customerName"] = customerData[data.customerId]
          dispatch(update_data(data))
          setSuccessMessage("Record updated successfully!")
          setTimeout(() => setSuccessMessage(""), 2000);
        }
        else{
          setErrorMessage("Error in updating the record!")
          setTimeout(() => setErrorMessage(""), 2000);
        }
      }).catch((err) => {
        setErrorMessage("480 error code!")
        setTimeout(() => setErrorMessage(""), 2000);
      })
      incrStateChange()
  }

  const searchAPI = (data, searchApiFlag, pageNumber) => {
    setFormOpen(false);
    clearSelectedRowId("-2")
    setPageNumber(pageNumber)
    // for using the get api
    if(!searchApiFlag){
      setGetApiFlag(!getApiFlag); 
    }
    else{
      dispatch(initiate_data([{"productDescription": "Please Wait!"}]));
      searchProductLineHistory(filerCode, countryToSearch, pageNumber, data).then((response) => {
        if(_.get(response, "data.eventMessage.header.code") === 200 && _.get(response, "data.eventMessage.header.msg") === "SUCCESS"){
          let pHistory = response?.data?.eventMessage?.productLineHistoryRecord || [];
          let newPHistory = pHistory.slice()
          // newPHistory.map((item)=>{
          //   item['customerName'] = customerData[item.customerId]
          // })
          dispatch(initiate_data(newPHistory));
          setTotalPages(Math.ceil(response?.data?.eventMessage?.totalCount / 100));
        }
        else{
          dispatch(initiate_data([{"productDescription": "No record found!"}]));
        }
      })
    }  
  }

  const deleteAPI = (productLineId) => {
      deleteProductLineHistory(productLineId).then((response) => {
        if(_.get(response, "data.eventMessage.header.code") === 200 && _.get(response, "data.eventMessage.header.msg") === "SUCCESS"){
          setFormOpen(false);
          dispatch(delete_data(productLineId))
          clearSelectedRowId("-2")
          setSuccessMessage("Record deleted successfully!")
          setTimeout(() => setSuccessMessage(), 2000);
        }
        else{
          setErrorMessage("Error in deleting the record!")
          setTimeout(() => setErrorMessage(""), 2000);
        }
      }).catch((err) => {
        setErrorMessage("480 error code!")
        setTimeout(() => setErrorMessage(""), 2000);
      })
  }

  const clearSelectedRowId = (id) => {
    if(id === "-2")
      setSelectedRowId("");
    else
      setSelectedRowId(id);
    
  }

  useEffect(() => {
    const customerId = sessionStorage.getItem("customerId") || getQueryVariable('cID');
    
    dispatch(initiate_data([{"productDescription": "Please Wait!"}]));
    let custObj = {}
    // getCustomerList(countryToSearch).then((response)=>{
    //   let data = get(response, "data.eventMessage.customers", []);
    //   data.map((item)=>{
    //     if(item.kxEmail){
    //       custObj[item.customerCode] = item.customerCode+ " - " + (item.kxEmail.split("@")[0]).toUpperCase()
    //     }
    //   })
    //   setCustomerData(custObj);
      let payload = {
        "pageNumber": pageNumber
      }
      if(window.typeOfUser === "BROKER_KN_ADMIN"){
        payload["countryOfRequest"] = countryToSearch
        payload["filerCode"] = filerCode
      }

      if (isEngine) {
        payload = {
          pageNumber,
          customerId,
          countryOfRequest:'US',
          engineUser: isEngine,
        }
      }

      getProductLineHistory(payload).then((response) => {
        let pHistory = response?.data?.eventMessage?.productLineHistoryRecord || [];
        let newPHistory = pHistory.slice()
        // newPHistory.map((item)=>{
        //     item['customerName'] = custObj[item.customerId]
        // })
        setTimeout(()=>{
          dispatch(initiate_data(newPHistory));
          setLoading(false)
        }, 0)
        setTotalPages(Math.ceil(response?.data?.eventMessage?.totalCount / 100))
      }); 
    // }).catch(() => {
    //   let payload = {
    //     "pageNumber": pageNumber
    //   }
    //   if(window.typeOfUser === "BROKER_KN_ADMIN"){
    //     payload["countryOfRequest"] = countryToSearch
    //     payload["filerCode"] = filerCode
    //   }

    //   if (isEngine) {
    //     payload = {
    //       pageNumber,
    //       customerId,
    //       countryOfRequest:'US',
    //       engineUser: isEngine,
    //     }
    //   }
    // })
    setDropdowns()
    
    if(window.shipmentCountry == "GB")
    {
      getDropdownValues().then((response) => {
        setCountryDropDownUK(response.data.eventMessage.countriesList)
      })
    }
  }, [countryToSearch, getApiFlag])

  const addAPITest = () => {
    addProductLineHistory("to be updated56", "newnewnew", "product tag", "thisisthemanufacturername", filerCode).then((response) => {
    })
  }
console.log("dropdownSerttttttt:", dropdownSet)
  return (
  <>
    <div className={"product-history-container outer-modal-container"}>
      <Segment className="history-modal-container modal-container">
        <span className="header-span" >
          <Header as="h1" className="header" >Product History</Header>
          {window.typeOfUser === "BROKER_KN_ADMIN" && <Dropdown
            placeholder='Select Country'
            lazyLoad={true}
            search
            selection
            value={countryToSearch}
            onChange={(e, data) => {
              setSelectedData(null)
              setFormOpen(false)
              setLoading(true)
              setSelectedRowId("-2")
              setCountryToSearch(data.value)
            }}
            options={countryOptions}
          />}
        </span>
       {!isEngine && <div className="table-app">
              { isLoading && <TableApp columns={columns} data={[{"productDescription": "Please Wait!"}]} method={setSelectedRowData} selectedRowId={selectedRowId} pageNumberMethod={changePageNumber} pageNumber={pageNumber} totalPages={totalPages} searchMethod={searchAPI} manualPagination={true} /> }
              { !isLoading && <TableApp columns={columns} data={prodList?.productHistory || [{"productDescription": "Please Wait!"}]} method={setSelectedRowData} selectedRowId={selectedRowId} pageNumberMethod={changePageNumber} pageNumber={pageNumber} totalPages={totalPages} searchMethod={searchAPI} manualPagination={true} /> }
        </div>}
            {successMessage && <div className={`successMessage`}><Icon name='check' color="green"/>{successMessage}</div>}
            {errorMessage && <div className={`errorMessage`}><Icon name='check' color="red"/>{successMessage}</div>}
            {neutralMessage && <div className="neutralMessage"><Icon name='sync alternate' color="black"/>{neutralMessage}</div>}
          {(isEngine && !dropdownSet) && <div>
              Loading PGA...
            </div>}
          { (!formOpen && formLoader) ? 
                <div className='entry-container'>
                    <Segment className="US-form-loader">
                        <Dimmer active inverted>
                        <Loader inverted>Loading</Loader>
                        </Dimmer>
                
                        <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />
                    </Segment>
                </div> :
                <div className="update-form">
                  { countryToSearch == "GB" && formOpen && <UpdateFormUK data={selectedData} updateAPI={updateAPI} deleteAPI={deleteAPI} selectedRowMethod={clearSelectedRowId} countryDropDownUK={countryDropDownUK} formReset={formReset} /> }
                  { countryToSearch == "CA" && formOpen && <UpdateFormCA data={selectedData} updateAPI={updateAPI} deleteAPI={deleteAPI} selectedRowMethod={clearSelectedRowId} formReset={formReset} /> }
                  { ((countryToSearch == "US" && formOpen) || (isEngine && dropdownSet)) && <UpdateFormUS data={selectedData} updateAPI={updateAPI} deleteAPI={deleteAPI} selectedRowMethod={clearSelectedRowId} formReset={formReset} /> }
                </div>
            }
            <a href="#" id="form-close">.</a>
      </Segment>
    </div>
  </>
  )
}

export default ManageProductHistory 